﻿/* ══════════════════════════════════════════════════════════════
   REYNA — wishlist toast
   XB Wishlist handles the saving; this only surfaces a confirmation
   so the customer gets feedback on the collection cards and PDP.
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var TOAST_ID = 'reyna-wishlist-toast';
  var timer = null;

  function toastEl() {
    var el = document.getElementById(TOAST_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = TOAST_ID;
    el.className = 'reyna-wl-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    return el;
  }

  function show(message) {
    var el = toastEl();
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(timer);
    timer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2400);
  }

  /* Delegated so it also covers cards added later by infinite scroll. */
  document.addEventListener(
    'click',
    function (event) {
      var add = event.target.closest('.xb-wishlist__add');
      if (add) {
        show('Saved to wishlist');
        return;
      }
      var remove = event.target.closest('.xb-wishlist__remove');
      if (remove) show('Removed from wishlist');
    },
    true
  );
})();
